import curry from "../../../lib/core/functional/curry";

const renderModule = curry(function renderCommentListModule(
    { Fragment, h },
    _context,
    { Comment },
    _altLoader
) {
    return function CommentList({ comments, ...props }) {
        const children = comments.map((comment) =>
            h(Comment, { key: comment.id, comment, ...props })
        );

        return h(Fragment, {}, children);
    };
});

export default function commentList({ preact }) {
    return renderModule(preact);
}
